import { useUser } from '@clerk/nextjs';
import { useUserContext } from '~/react_context/UserContext';
import { useCreateChatClient } from 'stream-chat-react';
import { getStreamChatBusinessTeamName } from '@utils/streamChatUtils';

export const useStreamChat = () => {
	const { user } = useUser();
	const { businessId, id, streamChatUserToken } = useUserContext();

	const apiKey = process.env.NEXT_PUBLIC_STREAM_CHAT_API_KEY!;
	const chatUserId = id!.toString();

	const client = useCreateChatClient({
		apiKey,
		tokenOrProvider: streamChatUserToken,
		userData: {
			id: chatUserId,
			image: user!.imageUrl ?? undefined,
			name: user!.fullName ?? 'Unknown User',
			teams: [getStreamChatBusinessTeamName(businessId)],
		},
	});

	return {
		chatUserId,
		client,
	};
};
